import React, { useState } from 'react';
import { useLabels } from 'wsm-common-data';
import { useGoogleApiSession } from '../hooks/useGoogleApiSession';
import { useFetchLocationSuggestions } from '../hooks/useFetchLocationSuggestions';
import { useLocationsFilter } from '../hooks/useLocationsFilter';
import AutocompleteSearch from '../components/AutocompleteSearch';
import SearchResultCount from '../components/SearchResultCount';
import ListAllLocationsLink from '../components/ListAllLocationsLink';
import MapToggleButton from '../components/MapToggleButton';
import FilterToggleButton from '../components/FilterToggleButton';

import '../global-sass/main.scss';

const Widget = () => {
	const labels = useLabels();
	const [inputString, setInputString] = useState('');
	const [selectedPlaceId, setSelectedPlaceId] = useState(null);
	const [hasLocations, setHasLocations] = useState(false);
	const { isApiReady, sessionToken, resetSession } =
		useGoogleApiSession(inputString);
	const { suggestions } = useFetchLocationSuggestions(
		inputString,
		sessionToken,
		isApiReady
	);

	useLocationsFilter(inputString);

	return (
		<div className="pb-4">
			<div className="row">
				<h2 className="col-xs-6 col-sm-4 text-left text-body px-5 px-md-3">
					{labels.get('LOCATIONS')}
				</h2>
				<div className="col-xs-6 col-sm-4 col-sm-push-4 text-right mt-5 px-5 px-md-3">
					<ListAllLocationsLink />
				</div>
				<div className="col-xs-12 col-sm-4 col-sm-pull-4 mt-md-5 mt-2 px-4 px-md-3">
					<AutocompleteSearch
						suggestions={suggestions}
						inputString={inputString}
						setInputString={setInputString}
						setSelectedPlaceId={setSelectedPlaceId}
					/>
				</div>
			</div>

			<div className="row d-flex align-items-center">
				<div className="col-xs-6 col-sm-4 text-center col-sm-push-4 px-5 px-md-3">
					<SearchResultCount
						isApiReady={isApiReady}
						sessionToken={sessionToken}
						resetSession={resetSession}
						selectedPlaceId={selectedPlaceId}
						onLocationStatusChange={setHasLocations}
					/>
				</div>
				<div className="col-xs-6 col-sm-4 col-sm-pull-4 text-right text-md-left px-5 px-md-3">
					{hasLocations && <FilterToggleButton />}
				</div>
				<div className="col-xs-6 col-sm-4 hidden-xs hidden-sm text-right">
					{hasLocations && <MapToggleButton />}
				</div>
			</div>
		</div>
	);
};

export default Widget;
